import { useCallback } from "react";

import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import useRestMutation from "@/remoteState/useRestMutation";

const useCreateTextSetContent = () => {
  const createTextSetContent = useCallback((payload) => {
    const requestParams = {
      method: "POST",
      body: JSON.stringify(payload),
      headers: { "Content-Type": "application/json" },
    };

    return new Request(
      `${MONOLITH_ORIGIN}/api/v3/content-membership/`,
      requestParams,
    );
  }, []);
  return useRestMutation(createTextSetContent);
};

export default useCreateTextSetContent;
